import endpointVersion from '@/helpers/endpoint-version';
import store from '@/store';
import axios from 'axios';
export const getConnectors = () => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    return axios.get(`/connector/getConnectors`, {
        baseURL: endpointVersion('v3'),
        params: {
            brand: brand.id,
        },
        headers: { Authorization: `Bearer ${tokenV3}` },
    });
};
export const getConnectorsByAudience = audienceId => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    return axios.get('/audience/getConnectorsByAudience', {
        baseURL: endpointVersion('v3'),
        headers: { Authorization: `Bearer ${tokenV3}` },
        params: {
            brand: brand.id,
            audienceId,
        },
    });
};
export const getFields = (params) => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    return axios.get(`/connector/getFields`, {
        baseURL: endpointVersion('v3'),
        params: {
            brand: brand.id,
            alias: params.connector,
            enabled: params.enabled ?? 1,
            instanceId: params.instanceId,
        },
        headers: { Authorization: `Bearer ${tokenV3}` },
    });
};
export const saveIntegration = (payload) => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    return axios.get('/audience/export', {
        baseURL: endpointVersion('v3'),
        headers: { Authorization: `Bearer ${tokenV3}` },
        params: {
            brand: brand.id,
            aid: payload.audienceId,
            connect: payload.aliasConnector,
            interval: payload.interval,
            instance: payload.instance,
            ...(payload.config && { config: payload.config }),
            ...(payload.startDate && { starting_date: payload.startDate }),
            ...(payload.aliasConnector === 'omnichat' && { export: payload.typeSendCampaign }),
        },
    });
};
export const deactivateIntegration = (payload) => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    return axios.get('/audience/updateSchedule', {
        baseURL: endpointVersion('v3'),
        headers: { Authorization: `Bearer ${tokenV3}` },
        params: {
            brand: brand.id,
            scheduleId: payload.scheduleId,
            connectorId: payload.connectorId,
            interval: payload.interval,
            enabled: payload.enabled,
        },
    });
};
